import React from "react";
import style from "./ConfirmationPopup.module.scss";

const ConfirmationPopup = ({ setModalVisible, message }) => {
  return (
    <div className={style.confirmationBlock}>
      <p dangerouslySetInnerHTML={{ __html: message }}></p>
    </div>
  );
};
export default ConfirmationPopup;
